import api from "../axios/axiosConfig";

/**
 * Consulta de CEP para preencher rua, bairro, cidade e UF no perfil.
 *
 * Sempre pela API da Spott (GET /AddressSearch/cep/{cep}), nunca direto num
 * servico externo: a fonte (hoje a ViaCEP) fica no backend e pode mudar sem
 * publicar o app. Falha nunca bloqueia o cadastro: o usuario digita o endereco
 * na mao.
 */
export type CepLookupResult = {
  street: string;
  neighborhood: string;
  city: string;
  state: string;
};

export const lookupCep = async (cep: string): Promise<CepLookupResult | null> => {
  const digits = (cep || "").replace(/\D/g, "");
  if (digits.length !== 8) return null;

  try {
    const response = await api.get(`/AddressSearch/cep/${digits}`);
    const data = response.data;
    if (!data) return null;

    return {
      street: data.street || "",
      neighborhood: data.neighborhood || "",
      city: data.city || "",
      state: data.state || "",
    };
  } catch {
    return null;
  }
};
